import { Paginated } from '@core/models/IApi';

export type AccOverApiRes = Paginated<Data[]>;

export interface Data {
    breakdown: Breakdown;
    data: Data2[];
}

export interface Breakdown {
    ig_account: Record<string, any>;
    ig_account_time: Record<string, any>;
}
export interface Data2 {
    ig_account: Record<string, any>;
    ig_account_time: Record<string, any>;
    social_media: Record<string, any>;
}

export class AccOverviewData {
    constructor(
        public account: AccOverviewUser,
        public impressions: number | undefined,
        public reach: Reach,
        public interactions: Interactions,
        public likes: MediaTypesCount,
        public comments: MediaTypesCount,
        public shared: MediaTypesCount,
        public saved: MediaTypesCount,
        public followers: Followers,
        public interactBreakdown: InteractionsBreakdown
    ) {}
}

export class AccOverviewUser {
    constructor(
        public igAccount: string | undefined,
        public image: string | undefined,
        public bio: string | undefined,
        public followers: number | undefined,
        public mediaCount: number | undefined
    ) {}
}

export class MediaTypesCount {
    constructor(
        public total: number | undefined,
        public ads: number | undefined,
        public posts: number | undefined,
        public reel: number | undefined,
        public stories: number | undefined
    ) {}
}

export class Reach extends MediaTypesCount {
    constructor(
        total: number | undefined,
        ads: number | undefined,
        posts: number | undefined,
        reel: number | undefined,
        stories: number | undefined,
        public followersPerc: number | undefined,
        public nonFollowersPerc: number | undefined,
        public unknownsPerc: number | undefined
    ) {
        super(total, ads, posts, reel, stories);
    }
}

export class Interactions extends MediaTypesCount {
    constructor(
        total: number | undefined,
        ads: number | undefined,
        posts: number | undefined,
        reel: number | undefined,
        stories: number | undefined,
        public accountsEngaged: number | undefined
    ) {
        super(total, ads, posts, reel, stories);
    }
}

export class Followers {
    constructor(
        public newFollowers: MetricBreakdown | undefined,
        public unfollowers: number | undefined,
        public unknown: number | undefined
    ) {}
}

export class InteractionsBreakdown {
    constructor(
        public profileViews: MetricBreakdown | undefined,
        public profileCta: number | undefined,
        public websiteClicks: number | undefined
    ) {}
}

export class MetricBreakdown {
    constructor(
        public total: number | undefined,
        public feed: number | undefined,
        public story: number | undefined
    ) {}
}
